import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../../lib/api";
import { Trash, EnvelopeOpen, Receipt, Calendar, Envelope } from "@phosphor-icons/react";
import { toast } from "sonner";

const tabs = [
  { key: "contacts",  label: "Messages",    icon: EnvelopeOpen },
  { key: "quotes",    label: "Quotes",      icon: Receipt },
  { key: "bookings",  label: "Bookings",    icon: Calendar },
  { key: "newsletter",label: "Subscribers", icon: Envelope },
];

export default function AdminInbox() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initial = searchParams.get("tab") || "contacts";
  const [tab, setTab] = useState(tabs.find((t) => t.key === initial) ? initial : "contacts");
  const [data, setData] = useState([]);

  const load = (t) => api.get(`/admin/${t}`).then((r) => setData(r.data));
  useEffect(() => { load(tab); setSearchParams({ tab }, { replace: true }); }, [tab]); // eslint-disable-line

  const del = async (id) => {
    if (tab === "newsletter") { toast("Cannot delete subscribers"); return; }
    if (!window.confirm("Delete?")) return;
    await api.delete(`/admin/${tab}/${id}`); toast.success("Deleted"); load(tab);
  };

  return (
    <div data-testid="admin-inbox">
      <h1 className="display-font text-3xl font-black uppercase mb-6">Inbox</h1>
      <div className="flex flex-wrap gap-2 mb-6">
        {tabs.map((tt) => {
          const Ic = tt.icon;
          return (
            <button key={tt.key} onClick={() => setTab(tt.key)}
              className={`flex items-center gap-2 px-4 py-2 mono-font text-xs uppercase tracking-widest border ${
                tab === tt.key ? "bg-[#ccff00] text-black border-[#ccff00]" : "border-[#2a2a35] text-gray-300 hover:border-[#ccff00]"
              }`}
              data-testid={`inbox-tab-${tt.key}`}>
              <Ic size={14} weight="bold" /> {tt.label}
            </button>
          );
        })}
      </div>

      <div className="space-y-3">
        {data.length === 0 && <div className="text-gray-500 mono-font text-sm">// EMPTY</div>}
        {data.map((d, i) => (
          <div key={d.id || i} className="card-dark p-5" data-testid={`inbox-row-${i}`}>
            <div className="flex justify-between items-start gap-4 mb-2">
              <div>
                {tab === "contacts" && <><div className="display-font font-bold">{d.name} · <span className="text-gray-400">{d.email}</span></div><div className="mono-font text-xs text-gray-500 mt-1">{d.subject}</div></>}
                {tab === "quotes"   && <><div className="display-font font-bold">{d.name} · <span className="text-gray-400">{d.email}</span></div><div className="mono-font text-xs text-gray-500 mt-1">Items: {d.items?.length || 0} · Event: {d.event_date || "-"}</div></>}
                {tab === "bookings" && <><div className="display-font font-bold">{d.name} · <span className="text-gray-400">{d.email}</span></div><div className="mono-font text-xs text-gray-500 mt-1">{d.service} · {d.date} {d.time}</div></>}
                {tab === "newsletter" && <div className="display-font font-bold">{d.email}</div>}
              </div>
              <div className="text-right">
                <div className="mono-font text-[10px] text-gray-500">{new Date(d.created_at).toLocaleString()}</div>
                {tab !== "newsletter" && (
                  <button onClick={() => del(d.id)} className="p-2 hover:text-[#ff003c] mt-1"><Trash size={16} /></button>
                )}
              </div>
            </div>
            {tab === "contacts" && d.message && <p className="text-sm text-gray-300 mt-3">{d.message}</p>}
            {tab === "quotes" && d.items && (
              <ul className="mt-3 grid gap-1 text-sm text-gray-300">
                {d.items.map((it, j) => <li key={j} className="mono-font text-xs">- {it.name_en} × {it.quantity}</li>)}
              </ul>
            )}
            {tab === "quotes" && d.notes && <p className="text-sm text-gray-400 mt-3">{d.notes}</p>}
            {tab === "bookings" && d.notes && <p className="text-sm text-gray-400 mt-3">{d.notes}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
